<div class="alphaBar" #alphaBar>
  <button *ngFor="let alpha of alphabets" class="alphaItem" [ngClass]="{
            'alphaInactive': !alphaHasEntry(alpha),
            'alphaSelected': selectedAlpha == alpha
          }" [disabled]="!alphaHasEntry(alpha)" (click)="alphaSelected(alpha)">
    {{ alpha }}
  </button>
</div>